<script lang="ts">
  import editorStore from '@/lib/editor/editor.store';
  import {SvelteComponent, SvelteComponentTyped, onDestroy, onMount} from 'svelte';
  export let title: string | null = null;
  export let component: typeof SvelteComponent | {component: typeof SvelteComponent; args: any} | null;
  export let open: boolean = false;
  export let expandable: boolean = true;
  export let nobg: boolean = false;
  export let noPadRight: boolean = false;
  export let clickable: null | ((args?: any[]) => any) = null;
  export let onMouseOver: () => any = () => {};
  export let onMouseLeave: () => any = () => {};
  export let titleComponents: {
    component: typeof SvelteComponent;
    args: any;
  }[] = [];
  function getToggleClass(state: boolean) {
    return state ? 'fa fa-angle-up' : 'fa fa-angle-down';
  }

  function openit() {
    open = true;
  }

  function closeit() {
    open = false;
  }

  function toggle() {
    if (clickable) return clickable();
    if (!expandable) return;
    open = !open;
  }

  function getComponent(component: any) {
    if (component.component) return component.component;
    return component;
  }

  function getArgs(component: any) {
    return component.args ? component.args : null;
  }

  function textToSnakeCase(text: string) {
    return text.replace(/\s+/g, '-').toLowerCase();
  }

  let unsubscribe: any;
  onMount(() => {
    if (component?.args?.reactTarget) {
      unsubscribe = editorStore.subscribe(store => {
        const target = document.querySelector(component.args.reactTarget);
        if (target) {
          if (store.activeComponent === target) {
            open = true;
          } else {
            open = false;
          }
        }
      });
    }
  });

  onDestroy(() => {
    if (unsubscribe) unsubscribe();
  });
</script>

<div
  on:mouseover={onMouseOver}
  on:mouseleave={onMouseLeave}
  on:focus={onMouseOver}
  class={`${title ? '' : 'moduleBlock'} flex flex-shrink-0 flex-col rounded-xl text-zinc-800  ${nobg ? '' : 'border border-gray-300 bg-white'} `}
>
  {#if title}
    <div
      class={`title ${noPadRight ? 'noPadRight' : ''} ${nobg ? '' : 'bg-white'} ${open ? 'active' : ''} ${
        !expandable ? 'cursor-default' : 'cursor-pointer'
      }
      ${clickable !== null ? 'cursor-pointer hover:bg-slate-100' : ''}
      `}
      on:keydown={toggle}
      on:click={toggle}
    >
      {#if expandable}
        <div class="toggleIcon w-5"><i class={getToggleClass(open)} /></div>
      {:else}
        <!-- <div class="w-5" /> -->
      {/if}
      <span class="block font-bold" id={textToSnakeCase(`sb-${title}`)}>{title}</span>
      {#each titleComponents as ComponentObject}
        <ComponentObject.component {...ComponentObject.args} on:open={openit} on:close={closeit} />
      {/each}
    </div>
  {/if}
  {#if component && open}
    <svelte:component this={getComponent(component)} {...getArgs(component)} />
  {/if}
</div>

<style lang="postcss">
  .moduleBlock {
    /* font-family: 'Roboto', sans-serif; */
    font-size: 1rem;
    @apply mb-8;
  }
  .title {
    @apply relative z-10 box-border flex min-h-14 items-center gap-2 rounded-b-xl rounded-t-xl px-4 py-4;
  }
  .title.noPadRight {
    @apply px-0;
  }
  .title.active {
    @apply rounded-b-none border-b border-gray-200;
  }
  .toggleIcon {
    --ggs: 0.5;
  }
</style>
